import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { useAppSelector } from "../../../../../hooks/store-hooks";
import { useProjetosService } from "../../../../../../use-cases/geo-veles";

export const FormEditProjeto = () => {
  // State
  const { editProjetoForm, projetoAberto, projetos } = useAppSelector((state) => state.projetos);
  // Service
  const { setOpenEditProjetoForm, setEditProjetoFormNome, updateProjeto } =
    useProjetosService();

  // Functions
  const handleClose = () => {
    setOpenEditProjetoForm({
      open: false,
      idVelesGeoProjeto: editProjetoForm.fields.idVelesGeoProjeto,
    });
  };
  
  const originalProject = projetoAberto?.IdVelesGeoProjeto === editProjetoForm.fields.idVelesGeoProjeto 
    ? projetoAberto 
    : projetos.find(p => p.IdVelesGeoProjeto === editProjetoForm.fields.idVelesGeoProjeto);

  const hasChanges = originalProject && (
    editProjetoForm.fields.nome !== originalProject.Nome ||
    editProjetoForm.fields.ativo !== originalProject.Ativo
  );

  return (
    <Dialog
      open={editProjetoForm.open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        component: "form",
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          updateProjeto();
        },
        sx: {
          borderRadius: "8px",
          padding: "16px",
        },
      }}
    >
      <DialogTitle sx={{ paddingBottom: "8px" }}>
        <Typography variant="h5" fontWeight="bold" color="#333">
          Editar projeto
        </Typography>
        <Typography variant="body2" color="#666" sx={{ mt: 1 }}>
          Escolha um nome para o projeto
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ paddingTop: "16px !important" }}>
        <Box sx={{ mt: 1 }}>
          <TextField
            autoFocus
            value={editProjetoForm.fields.nome}
            onChange={(e) => {
              setEditProjetoFormNome(e.target.value);
            }}
            error={Boolean(
              editProjetoForm.touched &&
                editProjetoForm.errors.find((item) => item.key === "nome")
            )}
            helperText={
              editProjetoForm.errors.find((item) => item.key === "nome")?.message
            }
            name="nome"
            fullWidth
            label="Digite o nome do projeto"
            variant="outlined"
            InputLabelProps={{
               shrink: true
            }}
            sx={{
               '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#9c27b0', // A roxo de acordo com a imagem
                  },
                  '&:hover fieldset': {
                    borderColor: '#7b1fa2',
                  },
               },
               '& .MuiInputLabel-root': {
                  color: '#9c27b0',
               }
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: "8px 24px 16px" }}>
        <Button
          onClick={handleClose}
          sx={{
            color: "#9c27b0",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "transparent" },
          }}
        >
          CANCELAR
        </Button>
        <Button
          type="submit"
          disabled={!hasChanges}
          sx={{
            color: "#9c27b0",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "transparent" },
            "&.Mui-disabled": {
              color: "#ccc",
            }
          }}
        >
          EDITAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};